import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CustomTexts } from './custom-texts';

@Component({
  selector: 'app-custom-page',
  templateUrl: './custom-page.component.html',
  styleUrls: ['./custom-page.component.scss']
})
export class CustomPageComponent implements OnInit {

  route: any;

  content: any;

  constructor(private router: Router) {

  }

  ngOnInit() {
    this.route = this.router.url;

    switch (this.route) {
      case '/privacy-policy':
        // call privacy policy
        this.content = CustomTexts.privacyPolicy;
        break;
      case '/terms-conditions':
        // call terms and conditions
        this.content = CustomTexts.termsConditions;
        break;
    }
  }

}
